import React from 'react'

interface ISizeCheckboxProps {
    id: string
    label: string
    checked: boolean
    onChange: () => void
}

/** Tamanho no filtro da listagem (bolinha com a sigla). */
const SizeCheckbox: React.FC<ISizeCheckboxProps> = ({ id, label, checked, onChange }) => (
    <>
        <input className="sr-only peer " type="checkbox" name="size[]" id={id} onChange={onChange} checked={checked} />
        <label
            className={`cursor-pointer border border-secondary text-secondary rounded-full text-sm font-semibold font-sora hover:bg-secondary hover:text-white flex items-center justify-center ${checked ? 'bg-secondary text-white' : ''}`}
            htmlFor={id}
        >
            <div className="h-8 w-8 flex items-center justify-center">{label}</div>
        </label>
    </>
)

export default SizeCheckbox
